import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HappyStoreDisabledService } from '../services/happy/happy-store-disabled.service';

const SILENT_URL_PATTERNS: RegExp[] = [
  /\/assets\/manifests\//
];

function isSilentRequest(url: string): boolean {
  return SILENT_URL_PATTERNS.some((pattern) => pattern.test(url));
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastrService: ToastrService = inject(ToastrService);
  const storeDisabledService: HappyStoreDisabledService = inject(
    HappyStoreDisabledService
  );

  return next(req).pipe(
    catchError((error) => {
      if (isSilentRequest(req.url)) {
        return throwError(() => error);
      }

      if (storeDisabledService.isStoreDisabledError(error)) {
        if (typeof window !== 'undefined') {
          window.location.reload();
        }
        return throwError(() => error);
      }

      let errorMessage =
        error?.error?.message ||
        error?.error?.error ||
        error?.error?.statusText;

      if (error?.error?.payment_result?.payment_status === 'failure') {
        errorMessage =
          'Payment processing failed. Please check your payment details and try again.';
      }

      toastrService.error(errorMessage || 'Something went wrong!');

      return throwError(() => error);
    })
  );
};
